import React,{useState} from 'react'
import './LoginForm.scss'
import { Button } from '../button/Button'
import {faGoogle, faSteam} from '@fortawesome/free-brands-svg-icons'
import {faEnvelope} from '@fortawesome/free-regular-svg-icons'
import {faLock} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const LoginForm = ({onClose,onRegister}) => {

    const [change,setChange] = useState({email:'', password:''})

    return (
        <>
            <div className="login">
                <div className="login__container">

                    <div className="login-closetag">
                        <p onClick={onClose}>X</p>
                    </div>

                    <div className="login__container-wrap">
                        <div className="login-header">
                            <h1>LOGIN</h1>
                        </div>
                        <div className="login-form-email">
                            <FontAwesomeIcon icon={faEnvelope} size='lg' className="close"/>
                            <input 
                                type="text" 
                                className="login-form-email-wrap" 
                                placeholder="Email"
                                value={change.email}
                                onChange={(e) => setChange({...change,email:e.target.value})}
                            />
                        </div>
                        <div className="login-form-password">
                            <FontAwesomeIcon icon={faLock} size='lg' className="close"/>
                            <input 
                                type="password"
                                className="login-form-password-wrap"
                                placeholder="Password"
                                value={change.password}
                                onChange={(e) => setChange({...change,password:e.target.value})}
                            />
                        </div>
                        <div className="login-check-rememberme">
                            <input type="checkbox" id="rememberme" value="rememberme" name="rememberme"/>
                            <label htmlFor="rememberme">Remember me</label>
                        </div>
                        <div className="login-button">
                            <Button buttonSize="btn--large" buttonColor="green">LOGIN</Button>
                        </div>
                        <div className="login-choose">
                            <p>Or login with</p>
                            <div className="login-choose-web">
                                <div className="login-choose-google">
                                    <FontAwesomeIcon icon={faGoogle} size='lg' className="close"/>
                                    <span></span>
                                    <p>Google</p>
                                </div>
                                <div className="login-choose-steam">
                                    <FontAwesomeIcon icon={faSteam} size='lg' className="close"/>
                                    <span></span>
                                    <p>Steam</p>
                                </div>
                            </div>
                        </div>
                        <div className="login-signup">
                            <p>Not a member ? <span onClick={onRegister}>Sign Up Now</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default LoginForm
